import React, { memo, useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ChevronRight from "@material-ui/icons/ChevronRight";
import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "./style.module.scss";

import { selectImageId } from "redux/image/selectors";
import { getAuditLogs } from "redux/app/actions";
import {
  selectAuditLogs,
  selectAuditUsers,
  selectAuditLoading,
} from "redux/app/selectors";
import LogRow from "./LogRow";

const AuditLogs = () => {
  const dispatch = useDispatch();
  const imageId = useSelector(selectImageId);
  const logs = useSelector(selectAuditLogs);
  const users = useSelector(selectAuditUsers);
  const loading = useSelector(selectAuditLoading);

  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  useEffect(() => {
    if (imageId) {
      dispatch(getAuditLogs({ imageId }));
    }
  }, [imageId, dispatch]);

  const getUserName = useCallback(
    (id) => {
      if (!id) return null;
      const user = users.find((u) => String(u.id) === String(id));
      return user?.name ?? `User #${id}`;
    },
    [users],
  );

  return (
    <div className={styles.container}>
      <div
        className={styles.headerAttributes}
        role="button"
        tabIndex="0"
        onClick={handleCollapse}
        onKeyPress={handleCollapse}
      >
        <div className={styles.headerLeft}>
          <button type="button">
            {isCollapsed ? <ChevronRight /> : <ExpandMore />}
          </button>
          <span>History</span>
        </div>
        <div className={styles.headerRight}>
          {!isCollapsed && loading && <CircularProgress size={14} />}
        </div>
      </div>

      {!isCollapsed && (
        <div style={{ maxHeight: "38vh", overflowY: "auto" }}>
          {loading ? (
            <div className="tw-flex tw-justify-center tw-py-4">
              <CircularProgress size={20} />
            </div>
          ) : logs.length === 0 ? (
            <div
              className="tw-text-center tw-text-gray-400"
              style={{ padding: "12px 16px", fontSize: 12 }}
            >
              No history available.
            </div>
          ) : (
            logs.map((log) => (
              <LogRow key={log._id} log={log} getUserName={getUserName} />
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default memo(AuditLogs);
